import { render, staticRenderFns } from "./VideoDisplay.vue?vue&type=template&id=a3e74380&scoped=true"
import script from "./VideoDisplay.vue?vue&type=script&lang=js"
export * from "./VideoDisplay.vue?vue&type=script&lang=js"
import style0 from "./VideoDisplay.vue?vue&type=style&index=0&id=a3e74380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e74380",
  null
  
)

export default component.exports